export const LINKS = {
  iss_travel_policy:
    "https://dsvcorp.sharepoint.com/sites/Policies/SitePages/Travel-policy.aspx",
  gdpr_clause:
    "https://dsvcorp.sharepoint.com/Sites/ISSC/Shared%20Documents/Forms/AllItems.aspx?id=%2FSites%2FISSC%2FShared%20Documents%2FAdministration%2FDSV%20ISSC%20Travel%2FDSV%5FISS%5FKlauzula%20obowi%C4%85zku%20informacyjnego%5FAplikacjka%5FTEA%2Epdf&parent=%2FSites%2FISSC%2FShared%20Documents%2FAdministration%2FDSV%20ISSC%20Travel",
  process_automation:
    "https://dsvcorp.sharepoint.com/Sites/ISSCProcessAutomation",
  service_now: "https://dsv.service-now.com/esc",
  manual:
    "https://dsvcorp.sharepoint.com/Sites/ISSCProcessAutomation/SitePages/Travel-&-Expenses-Assistant%20Manuals.aspx",
  logs: "/api/logs",
};
